import React from 'react'
import styled from 'styled-components';
import Particle from '../Components/Particle';
import { Button } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGithub,faLinkedin,faStackOverflow,faMedium } from '@fortawesome/free-brands-svg-icons'

function HomePage() {
    return (
        <HomePageStyled>
            <div className="particle-con">
                <Particle />
            </div>
            <div className="typography">
                <h1>Hi, I'm <span>Nadim 👋</span></h1>
                <p>
                A passionate Full Stack Software Developer 🚀 having an experience of building Web applications with JavaScript / Reactjs / Nodejs and some other cool libraries and frameworks.
                </p>
                <div className="icons">
                    <a href="https://www.linkedin.com/in/aa-nadim/" className="icon i-linkedin" target="_blank">
                        <FontAwesomeIcon icon={faLinkedin} />
                    </a>
                    <a href="https://github.com/aa-nadim" className="icon i-github" target="_blank">
                        <FontAwesomeIcon icon={faGithub} />
                    </a>
                    <a href="https://stackoverflow.com/users/14699990/nadim" className="icon i-stackOverflow" target="_blank">
                        <FontAwesomeIcon icon={faStackOverflow} />
                    </a>
                    <a href="https://aa-nadim.medium.com/" className="icon i-medium" target="_blank">
                        <FontAwesomeIcon icon={faMedium} />
                    </a>
                    <a href="https://www.stopstalk.com/user/profile/Garbage_Value" className="icon i-stopstalk" target="_blank"> 
                        <img src="https://avatars.githubusercontent.com/u/14951079?s=200&v=4" alt="stopstalk" width="35" height="35"/> 
                    </a>
                    {/* <a href="https://codeforces.com/profile/GarbageValue" className="icon i-codeforces" target="_blank">
                        <img src="https://4.bp.blogspot.com/-v-hzJIq0u7s/WtG1pXclDOI/AAAAAAAABwc/sSKMErfMuecOkdtentny-wBdNTtJi82oQCEwYBhgL/s1600/codeforce.png" alt="codeforces" width="30" height="30"/> 
                    </a> */}
                </div>
                <br />
                <Button variant="contained" color="primary" href="https://drive.google.com/uc?export=download&id=1F8gDKhethKOY83eMUIU6fN3WJQsKSIMq">Download Resume</Button>
            </div>
            
        </HomePageStyled>
    )
}

const HomePageStyled = styled.header`
    width: 100%;
    height: 100vh;
    position: relative;
   
    .typography{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        width: 80%;

        .icons{
            display: flex;
            justify-content: center;
            margin-top: 1rem;
            .icon{
                border: 2px solid var(--border-color);
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 50%;
                transition: all .4s ease-in-out;
                cursor: pointer;
                &:hover{
                    border: 2px solid var(--primary-color);
                    color: var(--primary-color);
                }
                &:not(:last-child){
                    margin-right: 1rem;
                }
                svg{
                    margin: .5rem;
                }
            }

            .i-linkedin{
                &:hover{
                    border: 2px solid blue;
                    color: blue;
                }
            }
            .i-github{
                &:hover{
                    border: 2px solid #5F4687;
                    color: #5F4687;
                }
            }
            .i-stackOverflow{
                &:hover{
                    border: 2px solid yellow;
                    color: yellow;
                }
            }
            .i-medium{
                &:hover{
                    border: 2px solid white;
                    color: skyblue;
                }
            }
            .i-stopstalk{
                &:hover{
                    border: 2px solid red;
                    color: red;
                }
            }
        }
    }
`;

export default HomePage;
